export default __webpack_public_path__ + "static/media/330_dummy2016-allgemeinarzt01-de.910a0d73.png";